/* Quote page (/pages/quote; QUOTE lane, sections/ls-quote.liquid): the list UI. The list is window.LSQuote (ls-base.js:
   storage key lumaspec-quote-v1, items {v, sku, t, h, i, q, o} + optional u (link), nu (not sold in the US)); a local
   fallback keeps the same key when ls-base.js has not run. Sending is assets/ls-rfq.js (the shared RFQ form): this
   script hands it the list, the hand-off context and the US check through form.lsRfq.
   Hand-offs: the configurator leaves sessionStorage lumaspec-quote-app (need text) + lumaspec-quote-config (its
   link); ?case=<handle> adds a case study's setup (sections/ls-quote-kit.liquid via the Section Rendering API);
   ?from=cart adds the cart's lines (/cart.js). */
(function () {
  'use strict';
  var root = document.querySelector('[data-ls-quote]');
  if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); };
  var KEY = 'lumaspec-quote-v1', mem = [];
  /* Interface strings: snippets/ls-quote-i18n.liquid (locales ls.quote.js; placeholders {n} in single braces so Liquid's
     t filter leaves them for this script), English defaults otherwise. Keys ending in _html hold markup. */
  var STR = {
    no_us: 'Not available in the United States. Available for delivery to other countries.',
    items_one: '({n} item)', items_other: '({n} items)',
    empty_html: 'Your quote list is empty. Add products with <b>Add to quote list</b> on any product page, build a system in the <a href="{url}">configurator</a>, or just describe what you need below.',
    quantity: 'Quantity', remove: 'Remove {name}',
    warn_one: '{n} item cannot be quoted for the United States. Remove it, or email support@lumaspecvision.com for delivery to another country.',
    warn_other: '{n} items cannot be quoted for the United States. Remove them, or email support@lumaspecvision.com for delivery to another country.',
    rm_one: 'Remove it', rm_other: 'Remove them',
    ctx_case: 'The proposed setup of the case study is in your list.', ctx_config: 'Your configured system is in the list.',
    back_case: 'Back to the case study', back_config: 'Back to the configurator',
    case_app: 'Setup from the case study "{title}" ({n} parts).',
    case_ctx: 'The proposed setup of "{title}" is in your list; change quantities or remove parts as you need.',
    case_added: 'Setup added to your quote list ({n} parts).',
    case_error: 'Could not load that case study setup. Add the parts from the case page, or describe it below.',
    err_name: 'Please enter your name.', err_email: 'Please enter a valid email address.',
    err_country: 'Please choose the delivery country.',
    err_empty: 'Add a product to your list, or describe what you need under Application.',
    err_us: 'Some items cannot be quoted for the United States: {no_us} Remove them from your list, or email support@lumaspecvision.com.',
    err_generic: 'Sorry, something went wrong. Please email support@lumaspecvision.com.',
    ctx_cart: 'Your cart is in the list.', back_cart: 'Back to the cart',
    cart_added: 'Your cart is now in your quote list.', cart_app: 'Formal quote for the parts in my cart.'
  };
  (function () {
    var el = document.querySelector('[data-ls-quote-i18n]'), d = {};
    try { d = JSON.parse(el ? el.textContent : '{}') || {}; } catch (e) { d = {}; }
    var dec = document.createElement('textarea');  // the t filter HTML-escapes plain keys: keep plain text, esc() on use
    Object.keys(d).forEach(function (k) {
      if (typeof d[k] !== 'string' || !d[k]) return;
      if (/_html$/.test(k)) STR[k] = d[k]; else { dec.innerHTML = d[k]; STR[k] = dec.value; }
    });
  })();
  function S(key, vars) { return String(STR[key]).replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? String(vars[k]) : m; }); }
  function P(key, n, vars) { vars = vars || {}; vars.n = n; return S(key + (n === 1 ? '_one' : '_other'), vars); }
  var NOUS = STR.no_us;
  var EN = /^en\b/i.test(document.documentElement.lang || 'en');  // the Worker's own error texts are English
  var SITE = 'https://lumaspecvision.com';
  var list = $('[data-q-list]'), form = $('form[data-ls-rfq]');
  if (!list || !form) return;
  var F = function (f) { return form.querySelector('[data-f="' + f + '"]'); };
  var need = F('need'), countryEl = F('country'), err = form.querySelector('[data-rfq-err]');
  var visitor = root.dataset.country || '';
  var opened = Date.now();
  var flagged = {};  // item key -> current boolean policy; false can supersede an older saved sensor flag
  var serverBlocked = {};  // authoritative refusals survive a late storefront refresh

  var Q = {
    list: function () {
      if (window.LSQuote) return window.LSQuote.list();
      try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { return mem; }
    },
    save: function (l) {
      if (window.LSQuote) return window.LSQuote.save(l);
      mem = l;
      try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) { /* storage blocked */ }
      document.querySelectorAll('[data-quote-count]').forEach(function (b) { b.textContent = l.length ? String(l.length) : ''; });
    },
    add: function (item) {
      if (window.LSQuote) return window.LSQuote.add(item);
      var k = keyOf(item), l = Q.list(), hit = l.filter(function (x) { return keyOf(x) === k; })[0];
      if (hit) hit.q += item.q || 1; else l.push(item);
      Q.save(l);
      return l;
    }
  };
  function keyOf(x) { return x.h + '|' + x.sku + '|' + JSON.stringify(x.o || null); }
  function isNoUsProduct(p) { return !!p && (p.tags || []).indexOf('no-us') >= 0; }
  function isNoUsItem(i) { var k = keyOf(i), value = flagged[k]; return !!serverBlocked[k] || (typeof value === 'boolean' ? value : !!i.nu); }
  // The empty-list link is created after Liquid has localized the rendered page's links.
  function configureUrl(value) {
    var url = value || '/pages/configure';
    var localeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return localeRoot && localeRoot !== '/' && url.indexOf('/pages/') === 0
      ? localeRoot.replace(/\/$/, '') + url : url;
  }
  // Known store items use direct product links in the selected language. Older saved configurations may carry
  // a legacy /p/ link; retain its query/fragment while using the item's current native handle. Explicit custom,
  // alternate-language and third-party destinations retain their own route.
  function itemUrl(i) {
    var native = /^lumaspec-/.test(i.h || '');
    var url = i.u || (native ? '/products/' + i.h : SITE + '/p/' + i.h + '/');
    if (!native) return url;
    try {
      var u = new URL(url, location.origin);
      if (u.origin !== location.origin) return url;
      if (/^\/p\/[^/]+\/?$/.test(u.pathname)) u.pathname = '/products/' + i.h;
      if (u.pathname.indexOf('/products/') !== 0) return url;
      var localeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (localeRoot !== '/') u.pathname = localeRoot.replace(/\/$/, '') + u.pathname;
      return u.pathname + u.search + u.hash;
    } catch (e) { return url; }
  }
  function country() { return countryEl ? String(countryEl.value || '').trim().toUpperCase() : ''; }
  function usDelivery() { return country() === 'US' || visitor === 'US'; }
  var toastTimer = 0;
  function toast(t) {
    var el = $('[data-q-toast]');
    el.textContent = t; el.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.hidden = true; }, 5000);
  }

  function paint() {
    var l = Q.list(), us = usDelivery();
    $('[data-q-n]').textContent = l.length ? P('items', l.length) : '';
    if (!l.length) {
      list.innerHTML = '<div class="ls-qp__empty">' + '<p>' + STR.empty_html.replace('{url}', esc(configureUrl(root.dataset.configure))) + '</p></div>';
      return;
    }
    var bad = 0;
    list.innerHTML = '<ul class="ls-qp__items">' + l.map(function (i, n) {
      var no = us && isNoUsItem(i);
      if (no) bad++;
      var opts = i.o && typeof i.o === 'object' ? Object.keys(i.o).map(function (k) { return k + ': ' + i.o[k]; }).join(', ') : i.o ? String(i.o) : '';
      return '<li class="ls-qp__item' + (no ? ' is-nous' : '') + '">' +
        '<a class="ls-qp__img" href="' + esc(itemUrl(i)) + '" tabindex="-1" aria-hidden="true">' + (i.i ? '<img src="' + esc(i.i) + '" alt="" width="80" height="64" loading="lazy">' : '') + '</a>' +
        '<div class="ls-qp__info"><a href="' + esc(itemUrl(i)) + '">' + esc(i.t || i.sku) + '</a><small>' + esc(i.sku || '') + (opts ? ' · ' + esc(opts) : '') + '</small>' +
        (no ? '<span class="ls-qp__nous">' + esc(NOUS) + '</span>' : '') + '</div>' +
        '<label class="ls-qp__qty"><span class="ls-sr">' + esc(STR.quantity) + '</span><input type="number" min="1" inputmode="numeric" value="' + (i.q || 1) + '" data-qn="' + n + '"></label>' +
        '<button type="button" class="ls-qp__rm" data-qrm="' + n + '" aria-label="' + esc(S('remove', { name: i.t || i.sku })) + '">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></li>';
    }).join('') + '</ul>' +
      (bad ? '<p class="ls-qp__warn">' + esc(P('warn', bad)) + ' <button type="button" class="linkbtn" data-qrm-us>' + esc(P('rm', bad)) + '</button></p>' : '');
  }
  // Recheck saved flags too: the 10-30 photoelectric exception can make an older nu flag stale.
  var checked = {};
  function checkUs() {
    if (!usDelivery()) return;
    Q.list().forEach(function (i) {
      var k = keyOf(i);
      if (checked[k] || !/^lumaspec-/.test(i.h || '')) return;
      checked[k] = true;
      fetch('/products/' + encodeURIComponent(i.h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p) {
            flagged[k] = p ? isNoUsProduct(p) : !!i.nu;
            paint();
          }
        }).catch(function () { /* the server checks again */ });
    });
  }

  list.addEventListener('change', function (ev) {
    var n = ev.target.getAttribute('data-qn'), l = Q.list();
    if (n === null || !l[n]) return;
    l[n].q = Math.max(1, Math.min(100000, parseInt(ev.target.value, 10) || 1));
    Q.save(l);
  });
  list.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-qrm],[data-qrm-us]');
    if (!t) return;
    var l = Q.list();
    if (t.hasAttribute('data-qrm-us')) l = l.filter(function (i) { return !isNoUsItem(i); });
    else l.splice(Number(t.getAttribute('data-qrm')), 1);
    Q.save(l);
    paint();
    if (err) err.hidden = true;
  });
  document.addEventListener('ls:quote-change', paint);
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });
  if (countryEl) countryEl.addEventListener('change', function () { paint(); checkUs(); });

  // hand-offs: configurator (sessionStorage) and case studies (?case=<handle>)
  var ctx = { source: '', config: '' };
  function context(text, link, label) {
    var p = $('[data-q-ctx]');
    p.hidden = false;
    p.innerHTML = esc(text) + (link ? ' <a href="' + esc(link) + '">' + esc(label) + '</a>' : '');
  }
  try {
    var app = sessionStorage.getItem('lumaspec-quote-app'), cfg = sessionStorage.getItem('lumaspec-quote-config');
    var src = sessionStorage.getItem('lumaspec-quote-source') || 'configure';
    if (app && need && !need.value) need.value = app;
    if (cfg) {
      ctx = { source: src, config: cfg };
      context(src === 'case' ? STR.ctx_case : src === 'cart' ? STR.ctx_cart : STR.ctx_config, cfg,
        src === 'case' ? STR.back_case : src === 'cart' ? STR.back_cart : STR.back_config);
    }
  } catch (e) { /* storage blocked */ }
  function addCase(handle) {
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(rootUrl + 'pages/cases/' + encodeURIComponent(handle) + '?section_id=ls-quote-kit')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ls-quote-kit]');
        var kit = JSON.parse(el.textContent);
        var once = 'lumaspec-quote-case-' + handle, seen = false;
        try { seen = sessionStorage.getItem(once) === '1'; sessionStorage.setItem(once, '1'); } catch (e) { /* storage blocked */ }
        if (!seen) kit.lines.forEach(function (l) { if (l.o === null) delete l.o; if (!l.u) delete l.u; l.v = l.v ? String(l.v) : ''; Q.add(l); });
        var link = location.origin + kit.url;
        if (need && !need.value) need.value = S('case_app', { title: kit.title, n: kit.lines.length });
        ctx = { source: 'case', config: link };
        try {
          sessionStorage.setItem('lumaspec-quote-app', need ? need.value : '');
          sessionStorage.setItem('lumaspec-quote-config', link);
          sessionStorage.setItem('lumaspec-quote-source', 'case');
        } catch (e) { /* storage blocked */ }
        context(S('case_ctx', { title: kit.title }), link, STR.back_case);
        if (!seen) toast(S('case_added', { n: kit.lines.length }));
      })
      .catch(function () { toast(STR.case_error); })
      .then(function () {
        var u = new URL(location.href);
        u.searchParams.delete('case');
        history.replaceState(null, '', u.pathname + u.search + u.hash);
        paint();
        checkUs();
      });
  }

  // the cart's "Request a quote for this cart" (?from=cart): its lines join the list once, then the parameter goes
  function addCart() {
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (c) {
        var lines = (c.items || []).map(function (i) {
          var o = null;
          (i.options_with_values || []).forEach(function (x) { if (x.name !== 'Title') { o = o || {}; o[x.name] = x.value; } });
          var it = { v: String(i.variant_id || ''), sku: i.sku || '', t: i.product_title || i.title, h: i.handle, i: i.image ? i.image + (i.image.indexOf('?') >= 0 ? '&' : '?') + 'width=200' : '', q: i.quantity || 1 };
          if (o) it.o = o;
          return it;
        });
        if (!lines.length) return;
        lines.forEach(function (l) { Q.add(l); });
        if (need && !need.value) need.value = S('cart_app', { n: lines.length });
        var link = location.origin + rootUrl + 'cart';
        ctx = { source: 'cart', config: link };
        try {
          sessionStorage.setItem('lumaspec-quote-app', need ? need.value : '');
          sessionStorage.setItem('lumaspec-quote-config', link);
          sessionStorage.setItem('lumaspec-quote-source', 'cart');
        } catch (e) { /* storage blocked */ }
        context(STR.ctx_cart, link, STR.back_cart);
        toast(S('cart_added', { n: lines.length }));
      })
      .catch(function () { /* nothing to add: the list stays as it is */ })
      .then(function () {
        var u = new URL(location.href);
        u.searchParams.delete('from');
        history.replaceState(null, '', u.pathname + u.search + u.hash);
        paint();
        checkUs();
      });
  }

  // the shared RFQ sender (ls-rfq.js) asks this page for its items, context and US check
  form.lsRfq = {
    items: function () { return Q.list(); },
    ctx: function () { return { source: ctx.source, config: ctx.config }; },
    check: function () {
      return usDelivery() && Q.list().some(isNoUsItem) ? S('err_us', { no_us: NOUS }) : '';
    },
    noUsMessage: S('err_us', { no_us: NOUS }),
    refused: function (d) {
      (d.no_us || []).forEach(function (s) { Q.list().forEach(function (i) { if (i.sku === s || i.h === s) serverBlocked[keyOf(i)] = true; }); });
      if (d.no_us) paint();
    },
    sent: function () {
      try { ['lumaspec-quote-app', 'lumaspec-quote-config', 'lumaspec-quote-source'].forEach(function (k) { sessionStorage.removeItem(k); }); } catch (e) { /* */ }
    }
  };
  var params = new URLSearchParams(location.search), caseHandle = params.get('case');
  if (caseHandle && /^[a-z0-9][a-z0-9-]{0,120}$/.test(caseHandle)) addCase(caseHandle);
  else if (params.get('from') === 'cart') addCart();
  else { paint(); checkUs(); }
})();
